import { IMotorsportsTeamsStandings, MotorsportsTeamsStandings } from "@sky-it-livedata/livedata-sports-design-system";

import { WidgetContext } from "../../types/WidgetContext";
import { log } from "../../utils/log";
import { TeamsRankingQuery } from "./types";

import transformQuery from "./transformers/query-transformer";
import { useIntcmp } from '../../hooks/useIntcmp';

export const setCustomAttributes = ({
  variables,
}: WidgetContext<TeamsRankingQuery>) => {
  return {
    variables: JSON.stringify(variables),
  };
};

export const getServerProps = ({
    props,
}: WidgetContext<TeamsRankingQuery> ): IMotorsportsTeamsStandings => {
    return transformQuery(props);
};

const TeamsRanking = ({
    props,
    ...rest
}: WidgetContext<IMotorsportsTeamsStandings> ) => {
    log({ props, ...rest });
    const intCmpEventHandler = useIntcmp();

    return (
        <div onClick={intCmpEventHandler}>
            <MotorsportsTeamsStandings {...props} />
        </div>
    );
}

export default TeamsRanking